import React from 'react'
import {FormControl, Grid, InputLabel, makeStyles, Select} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: `0.25em 0`,
        [theme.breakpoints.down('xs')]: {
            margin: '0.5em 0'
        },
    },
}));

export default function ModuleForm ({label, module, name, handleChange,register}) {
    const classes = useStyles();
    return (
        <Grid item sm={4} xs={12}>
            <FormControl variant="outlined" className={classes.formControl} fullWidth>
                <InputLabel htmlFor={label}> {label} </InputLabel>
                <Select native name={name} onChange={handleChange} label={label} inputRef={register}>
                    <option aria-label="None" value=""/>
                    {
                        module?.length > 0 &&
                        module.map(({id, title}) => <option key={id} value={id}>{title}</option>)
                    }
                </Select>
            </FormControl>
        </Grid>
    )
};